export default {
    name: 'ArrowDiagonalDownSmall',
    dimensions: { width: 10, height: 10 },
    content: `<path fill-rule="evenodd" clip-rule="evenodd" d="M9.70711 0.292895C10.0976 0.683419 10.0976 1.31658 9.70711 1.70711L3.41421 8L7 8C7.55228 8 8 8.44772 8 9C8 9.55229 7.55228 10 7 10L0.999998 10C0.447713 10 -1.67017e-06 9.55229 -1.57361e-06 9L-5.24537e-07 3C-4.27972e-07 2.44772 0.447715 2 1 2C1.55228 2 2 2.44772 2 3L2 6.58579L8.29289 0.292895C8.68342 -0.0976296 9.31658 -0.0976295 9.70711 0.292895Z" fill="currentColor"/>`
};
